import { AppConfiguration } from "../app-configuration";
export class CommonsConfiguration {
    // COMMON URLs
    public static getMenuHomePage = AppConfiguration.COMMONS + '/getMenuHomePage';
    public static ricercaDecreti = AppConfiguration.COMMONS + '/ricercaDecreti';
    public static assistenza = AppConfiguration.COMMONS + '/email/assistenza';
    public static inviaEmailAssistenza = AppConfiguration.COMMONS + '/email/inviaEmailAssistenza';
    public static ricercaFigure = AppConfiguration.COMMONS + '/ricercaFigure';
    public static ricercaHomePageAllegati = AppConfiguration.COMMONS + '/ricercaHomePageAllegati';
    public static downloadManuale = AppConfiguration.COMMONS + '/manualistica/downloadManuale';
    public static ricercaNormative = AppConfiguration.COMMONS + '/ricercaNormative';
    public static ricercaPercorsiRegolamentati = AppConfiguration.COMMONS + '/ricercaPercorsiRegolamentati';
    public static getVersione = AppConfiguration.COMMONS + '/getVersione';
    // public static getLogout = 'qrsp30-api/logout';


    // ricerca profili e competenze home page
    public static getProfiloDettaglio = AppConfiguration.COMMONS + '/getProfiloDettaglio/';
    public static getCodiciAdaByIdProposta = AppConfiguration.COMMONS + '/getCodiciAdaByIdProposta/';
    public static getCodiciAtecoByIdProposta = AppConfiguration.COMMONS + '/getCodiciAtecoByIdProposta/';
    public static getCodiciIscoByIdProposta = AppConfiguration.COMMONS + '/getCodiciIscoByIdProposta/';
    public static getCodiciIstatByIdProposta = AppConfiguration.COMMONS + '/getCodiciIstatByIdProposta/';
    public static getCompetenzeByIdProposta = AppConfiguration.COMMONS + '/getCompetenzeByIdProposta/';
    public static getCompetenzeByPropostaIdAndTipologiaIdAndDescrizione = AppConfiguration.COMMONS + '/competenzefiltered';
    public static getCompetenzeByTipologiaIdAndDescrizione = AppConfiguration.COMMONS + '/competenze';
    public static getSottoCategoriaCompetenzaDiBase = `${AppConfiguration.COMMONS}/competenzabase/sottocategorie`;
    public static getTipologiaAreaProfilo = AppConfiguration.COMMONS + '/areaProfili';
    public static getAbilitaByCompetenza = AppConfiguration.COMMONS + '/getAbilitaByCompetenza/';
    public static getConoscenzeByCompetenza = AppConfiguration.COMMONS + '/getConoscenzeByCompetenza/';
    public static reportPropostaCompetenzaPdf = AppConfiguration.COMMONS + '/reportPropostaCompetenzaPdf/';
    public static getTAreaProfilo = AppConfiguration.COMMONS + '/areaprofilo';
    public static getTipologiaCompetenza = AppConfiguration.COMMONS + '/getTipologiaCompetenza';

    public static homePageDownloadDocumento = AppConfiguration.COMMONS + '/homePageDownloadDocumento'

    public static getCompetenzaDettaglio = AppConfiguration.COMMONS + '/getCompetenzaDettaglio/';
    public static getCodiciAdaByIdCompetenza = AppConfiguration.COMMONS + '/getCodiciAdaByIdCompetenza/';
    public static getCodiciAtecoByIdCompetenza = AppConfiguration.COMMONS + '/getCodiciAtecoByIdCompetenza/';
    public static getCodiciIscoByIdCompetenza = AppConfiguration.COMMONS + '/getCodiciIscoByIdCompetenza/';
    public static getCodiciIstatByIdCompetenza = AppConfiguration.COMMONS + '/getCodiciIstatByIdCompetenza/';
    public static getProfiliProfessionaliByIdCompetenza = AppConfiguration.COMMONS + '/getProfiliProfessionaliByIdCompetenza/';

    public static getListaCorsi = AppConfiguration.COMMONS + '/corsi/getListaCorsi';
}
